import {getLanguageScope} from '../../../helpers';
import * as Yup from 'yup';

const _i18n = getLanguageScope('clerks_management');

const newClerkSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, _i18n('too_short'))
    .max(50, _i18n('too_long'))
    .required(_i18n('required')),
  lastName: Yup.string()
    .min(2, _i18n('too_short'))
    .max(50, _i18n('too_long'))
    .required(_i18n('required')),
  phone: Yup.string()
    .required(_i18n('required'))
    .matches(/\+1 \(\d{3}\) \d{3}-\d{4}/, _i18n('dont_match_phone'))
    .min(11, _i18n('too_short')),
  email: Yup.string()
    .email(_i18n('invalid_email'))
    .required(_i18n('required')),
  password: Yup.string()
    .min(8, _i18n('password_short'))
    .required(_i18n('required')),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], _i18n('password_not_the_same'))
    .required(_i18n('required')),
});

const deviceSchema = Yup.object().shape({
  deviceName: Yup.string()
    .min(2, _i18n('too_short'))
    .max(50, _i18n('too_long'))
    .required(_i18n('required')),
});

const changePasswordSchema = Yup.object().shape({
  old_password: Yup.string()
    .required(_i18n('required')),
  new_password: Yup.string()
    .min(8, _i18n('password_short'))
    .required(_i18n('required')),
  confirm_new_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], _i18n('password_not_the_same'))
    .required(_i18n('required')),
});

const editClerkSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(2, _i18n('too_short'))
    .max(50, _i18n('too_long'))
    .required(_i18n('required')),
  last_name: Yup.string()
    .min(2, _i18n('too_short'))
    .max(50, _i18n('too_long'))
    .required(_i18n('required')),
  email: Yup.string()
    .email(_i18n('invalid_email'))
    .required(_i18n('required'))
});


export {
  newClerkSchema,
  deviceSchema,
  changePasswordSchema,
  editClerkSchema
}



// WEBPACK FOOTER //
// ./src/components/Clerks/models/formValidation.js